import * as React from 'react';
import { text } from '../common/text';

export const Heading: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  const welcomeTexts = text('LBL_WELCOME').split('Untis');

  return (
    <h1
      style={{
        color: '#67747E',
        maxWidth: 180,
        fontSize: 32,
        fontWeight: 600,
        lineHeight: '44px',
        textAlign: 'center',
        display: 'inline-block',
        ...style,
      }}
    >
      {welcomeTexts[0]}
      <span style={{ color: '#FF6033' }}>Untis</span>
      {welcomeTexts[1] || ''}
    </h1>
  );
};



// WEBPACK FOOTER //
// ./src/components/Heading.tsx